export const WAEC_VISUAL_ARTS = [];
